export const noIndexMeta = { name: 'robots', content: 'noindex' }
